import getAvailability from "@/vue/planning/logic/getAvailability";
import { packConfigForCheckingAvailability } from "@/config/packConfigForCheckingAvailability";
import { AvailabilitiesResponse } from "@/types/responses";
import flightPackCode, { isFlightEnabledLocale } from "@/config/flightPackCode";
import useLocale from "@/vue/composables/useLocale";

const getFirstAvailableResponse = async (
	storeObj: any,
	hashPackCode: string | undefined
): Promise<AvailabilitiesResponse> => {

	const flightEnabled = isFlightEnabledLocale(useLocale())
	const packConfigClone = [...packConfigForCheckingAvailability].filter(
		(code) => flightEnabled || !flightPackCode.includes(code)
	)
	// TODO if packcode in url, use it
	if (hashPackCode && (flightEnabled || !flightPackCode.includes(hashPackCode))) {
		packConfigClone.unshift(hashPackCode)
	}
	
	for (const packCode of packConfigClone) {
		const avail_resp: AvailabilitiesResponse | null = await getAvailability(
			packCode,
			storeObj.state.dates.BeginDate,
			storeObj.state.dates.EndDate,
			storeObj
		);
		if (
			avail_resp &&
			avail_resp["endDates"] &&
			avail_resp["endDates"]["startDate"]
		) {
			storeObj.state.currentPackCode = packCode;
			storeObj.state.reviewNumberPerLihe = avail_resp.reviewNumberPerLihe;
			storeObj.state.averageRatingPerLihe = avail_resp.averageRatingPerLihe;
			return avail_resp;
		}
	}
	return {};
};

export default getFirstAvailableResponse;
